module.exports = __webpack_public_path__ + "assets/StarCheckIcon.978f2df4889c3deaa84316d81408585c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/StarCheckIcon.svg
// module id = 90
// module chunks = 0